import * as yup from 'yup'

export class VehicleCheckInManufacturerLabelDatesDto {
  manufacturerLabelOrderedDate?: string = undefined
  manufacturerLabelReceivedDate?: string = undefined
  vehicleCheckInIsManufacturersLabelPhotoMissing?: boolean = undefined
}

export const vehicleCheckInManufacturerLabelDatesValidationSchema = yup.object({
  manufacturerLabelOrderedDate: yup.date().typeError('Manufacturer Label Ordered must be a date.').nullable(),
  manufacturerLabelReceivedDate: yup.date().typeError('Manufacturer Label Received must be a date.').nullable()
})
